import { FC } from 'react';
import {
  Toggle,
  Theme,
  ToggleStyle,
  TextOnly,
  TextFormatType,
  TextAlignType,
  useTranslation,
} from '@nextgen-web-framework/all';
import { type AutoContinueSwitchProps } from './types/propTypes';
import styles from './AutoContinueSwitch.module.scss';

const AutoContinueSwitch: FC<AutoContinueSwitchProps> = ({
  onClick,
  isSwitchEnabled,
  subDescription = '',
}: AutoContinueSwitchProps) => {
  const translate = useTranslation();

  const getSubDescription = () => (subDescription ? `&lt;div&gt;${subDescription}&lt;/div&gt;` : '');

  return (
    <div
      className={styles['auto-continue-component-container']}
      data-active={isSwitchEnabled}
      data-testid="auto-continue-toggle"
    >
      <TextOnly
        className={styles['auto-continue-text-container']}
        titleConfig={{
          alignment: TextAlignType.LEFT,
          formatType: TextFormatType.H4,
          text: translate('subscription.autoContinue.title'),
        }}
        descriptionConfig={{
          alignment: TextAlignType.LEFT,
          description: `&lt;div&gt;${translate('subscription.autoContinue.description')}&lt;/div&gt;${getSubDescription()}`,
        }}
      />
      <div className={styles['auto-continue-switch-container']}>
        <Toggle isActive={isSwitchEnabled} onClick={onClick} theme={Theme.BLACK} toggleStyle={ToggleStyle.SWITCH} />
      </div>
    </div>
  );
};

export default AutoContinueSwitch;
